import { Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import PartnerDashboard from "@/pages/PartnerDashboard";
import PartnerMarkets from "@/pages/partner/PartnerMarkets";
import ProfileSettings from "@/pages/ProfileSettings";
import AccessDenied from "@/pages/AccessDenied";
import AdminDashboard from "@/pages/AdminDashboard";
import PortfolioManagement from "@/pages/PortfolioManagement";
import BlogManagement from "@/pages/BlogManagement";
import InternalDistribution from "@/pages/InternalDistribution";
import SecurityDashboard from "@/pages/SecurityDashboard";
import ClientDocsManager from "@/pages/ClientDocsManager";
import DocumentLibrary from "@/pages/DocumentLibrary";
import MobileHome from "@/pages/mobile/MobileHome";
import MobileInbox from "@/pages/mobile/MobileInbox";
import MobilePortfolioGlance from "@/pages/mobile/MobilePortfolioGlance";
import MobileComplianceTrafficLight from "@/pages/mobile/MobileComplianceTrafficLight";
import MobileComplianceFindings from "@/pages/mobile/MobileComplianceFindings";
import MobileAsk from "@/pages/mobile/MobileAsk";
import MobileMeetingPrep from "@/pages/mobile/MobileMeetingPrep";
import MobileBrief from "@/pages/mobile/MobileBrief";
import MobileSourceReader from "@/pages/mobile/MobileSourceReader";
import MobileMarkets from "@/pages/mobile/MobileMarkets";
import MobileBriefDetail from "@/pages/mobile/MobileBriefDetail";
import MobileSecurity from "@/pages/mobile/MobileSecurity";
import MobilePodcast from "@/pages/mobile/MobilePodcast";
import PodcastAdmin from "@/pages/admin/PodcastAdmin";
import AdvisersAdmin from "@/pages/admin/AdvisersAdmin";
import MeetingRequest from "@/pages/MeetingRequest";
import FundManagerForms from "@/pages/FundManagerForms";
import AboutEditor from "@/pages/AboutEditor";
import AdviserAssistEditor from "@/pages/AdviserAssistEditor";
import AdviserClientPresentation from "@/pages/AdviserClientPresentation";
import CBAMMMReporting from "@/pages/CBAMMMReporting";
import Tier1PolicyEditor from "@/pages/Tier1PolicyEditor";
import Tier1Policy from "@/pages/Tier1Policy";
import Tier1PolicySection from "@/pages/Tier1PolicySection";
import TeamManagement from "@/pages/TeamManagement";
import BenchmarkLayout from "@/pages/benchmark/BenchmarkLayout";
import BenchmarkDashboard from "@/pages/benchmark/BenchmarkDashboard";
import FundManagement from "@/pages/benchmark/FundManagement";
import TradeLog from "@/pages/benchmark/TradeLog";
import InvestableUniverse from "@/pages/benchmark/InvestableUniverse";
import FundSectorWeightingsTabs from "@/pages/benchmark/FundSectorWeightingsTabs";
import PSectorWeightings from "@/pages/benchmark/PSectorWeightings";
import RBenchmarkLayout from "@/pages/r-benchmark/RBenchmarkLayout";
import RBenchmarkDashboard from "@/pages/r-benchmark/RBenchmarkDashboard";
import RFundManagement from "@/pages/r-benchmark/RFundManagement";
import RSectorWeightings from "@/pages/r-benchmark/RSectorWeightings";
import RHypotheticalCalculator from "@/pages/r-benchmark/RHypotheticalCalculator";
import RTradeLog from "@/pages/r-benchmark/RTradeLog";
import DistBenchmarkLayout from "@/pages/dist-benchmark/DistBenchmarkLayout";
import DistBenchmarkDashboard from "@/pages/dist-benchmark/DistBenchmarkDashboard";
import DistFundManagement from "@/pages/dist-benchmark/DistFundManagement";
import DistSectorWeightings from "@/pages/dist-benchmark/DistSectorWeightings";
import DistHypotheticalCalculator from "@/pages/dist-benchmark/DistHypotheticalCalculator";
import DistTradeLog from "@/pages/dist-benchmark/DistTradeLog";
import MmBenchmarkLayout from "@/pages/mm-benchmark/MmBenchmarkLayout";
import MmBenchmarkDashboard from "@/pages/mm-benchmark/MmBenchmarkDashboard";
import MmFundManagement from "@/pages/mm-benchmark/MmFundManagement";
import MmSectorWeightings from "@/pages/mm-benchmark/MmSectorWeightings";
import MmTradeLog from "@/pages/mm-benchmark/MmTradeLog";
import MmHoldingsDuration from "@/pages/mm-benchmark/MmHoldingsDuration";
import PRiskLayout from "@/pages/risk/PRiskLayout";
import RRiskLayout from "@/pages/risk/RRiskLayout";
import PVaR from "@/pages/risk/PVaR";
import RVaR from "@/pages/risk/RVaR";
import PStress from "@/pages/risk/PStress";
import RStress from "@/pages/risk/RStress";
import PBoard from "@/pages/risk/PBoard";
import RBoard from "@/pages/risk/RBoard";
import BenchmarkMaintenanceLayout from "@/pages/benchmark-maintenance/BenchmarkMaintenanceLayout";
import BenchmarkSummary from "@/pages/benchmark-maintenance/BenchmarkSummary";
import FundHouseSectorMapping from "@/pages/benchmark-maintenance/FundHouseSectorMapping";
import FundHouseHoldings from "@/pages/benchmark-maintenance/FundHouseHoldings";
import BMAuditTrail from "@/pages/benchmark-maintenance/BMAuditTrail";
import ComplianceLayout from "@/pages/compliance/ComplianceLayout";
import ComplianceDashboard from "@/pages/compliance/ComplianceDashboard";
import ComplianceBreaches from "@/pages/compliance/ComplianceBreaches";
import ComplianceGovernance from "@/pages/compliance/ComplianceGovernance";
import ComplianceConflicts from "@/pages/compliance/ComplianceConflicts";
import ComplianceMI from "@/pages/compliance/ComplianceMI";
import ComplianceAmendments from "@/pages/compliance/ComplianceAmendments";
import ComplianceThresholds from "@/pages/compliance/ComplianceThresholds";
import ThresholdProvenance from "@/pages/compliance/ThresholdProvenance";
// ── Added when this branch was rebased onto main (2026-08-04) ────────────────────────────────────
// These surfaces landed on main AFTER this branch was cut, straight into the monolithic App.tsx that
// this branch deletes. Without porting them here they would silently disappear from the app: the
// native meetings module, the Investment Reporting island, and mobile My Captures. They belong in
// partnerOpsRoutes because it is composed by AppInternal ONLY, so they stay absent from the adviser
// and public bundles by construction — which is the whole point of the three-target split.
import MeetingBooked from "@/pages/MeetingBooked";
import MeetingReport from "@/pages/MeetingReport";
import MeetingsReferenceData from "@/pages/MeetingsReferenceData";
import MobileMyCaptures from "@/pages/mobile/MobileMyCaptures";
import InvestmentReportingLayout, {
  ReportingCycleLayout,
  ReportingCycleIndex,
} from "@/pages/investment-reporting/ReportingCycleLayout";
import ReportingCycleList from "@/pages/investment-reporting/ReportingCycleList";
import ReportTab from "@/pages/investment-reporting/ReportTab";
import FlagsTab from "@/pages/investment-reporting/FlagsTab";
import ArtifactsTab from "@/pages/investment-reporting/ArtifactsTab";
import NewsletterTab from "@/pages/investment-reporting/NewsletterTab";
import GateTab from "@/pages/investment-reporting/GateTab";
import IntakeTab from "@/pages/investment-reporting/IntakeTab";
import SleevesTab from "@/pages/investment-reporting/SleevesTab";
import YardeniSecondOpinion from "@/pages/investment-reporting/YardeniSecondOpinion";
import YardeniCurate from "@/pages/investment-reporting/YardeniCurate";

// INTERNAL-only partner/admin ops routes — everything under /partner/* and /admin/* that is NOT the
// proprietary research surface (that lives in researchRoutes.tsx), plus the misc top-level internal
// routes (meeting-request, fund-manager-forms, year-end-review). Composed by AppInternal ONLY. These
// are all staff-facing ops surfaces; adviser/public never import this fragment. Moved verbatim out of
// the original App.tsx so internal behaviour is unchanged.
export function partnerOpsRoutes() {
  return (
    <>
      {/* Backward compatibility redirects */}
      <Route path="/staff-login" element={<Navigate to="/partner/login" replace />} />
      <Route path="/staff-dashboard" element={<Navigate to="/partner/dashboard" replace />} />
      <Route path="/profile-settings" element={<Navigate to="/partner/profile" replace />} />
      <Route path="/blog-management" element={<Navigate to="/partner/blog-management" replace />} />
      <Route path="/admin-dashboard" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="/portfolio-management" element={<Navigate to="/admin/portfolio-management" replace />} />
      <Route path="/security-dashboard" element={<Navigate to="/admin/security" replace />} />

      {/* Protected partner routes - wrapped in Layout */}
      <Route path="/partner/dashboard" element={
        <ProtectedRoute>
          <Layout>
            <PartnerDashboard />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/staff/dashboard" element={<Navigate to="/partner/dashboard" replace />} />
      {/* Mobile (native) IA landing pages — Home + Inbox tabs (P0-IA-02). */}
      <Route path="/partner/m/home" element={
        <ProtectedRoute>
          <Layout>
            <MobileHome />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/m/inbox" element={
        <ProtectedRoute>
          <Layout>
            <MobileInbox />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/m/portfolio" element={
        <ProtectedRoute>
          <Layout>
            <MobilePortfolioGlance />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/m/compliance" element={
        <ProtectedRoute>
          <Layout>
            <MobileComplianceTrafficLight />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile per-portfolio compliance findings drill-down + acknowledge (research-visibility). */}
      <Route path="/partner/m/compliance/:portfolio" element={
        <ProtectedRoute>
          <Layout>
            <MobileComplianceFindings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/m/ask" element={
        <ProtectedRoute>
          <Layout>
            <MobileAsk />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/m/prep" element={
        <ProtectedRoute>
          <Layout>
            <MobileMeetingPrep />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile daily audio-brief player (AUD-4, Phase 2). */}
      <Route path="/partner/m/brief" element={
        <ProtectedRoute>
          <Layout>
            <MobileBrief />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile full IG watch list — all 34 instruments, grouped by asset class (research-visibility). */}
      <Route path="/partner/m/markets" element={
        <ProtectedRoute>
          <Layout>
            <MobileMarkets />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile full prebrief digest for one surface (research-visibility). */}
      <Route path="/partner/m/brief-detail/:surface" element={
        <ProtectedRoute>
          <Layout>
            <MobileBriefDetail />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile source/transcript reader + vocal-emotion overlay (CAP-2.3, Phase 2). */}
      <Route path="/partner/m/source/:id" element={
        <ProtectedRoute>
          <Layout>
            <MobileSourceReader />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile Security & devices — device-session list + remote wipe (Phase 1). */}
      <Route path="/partner/m/security" element={
        <ProtectedRoute>
          <Layout>
            <MobileSecurity />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Mobile podcast — native audio preferred (podcast publish pipeline), YouTube iframe fallback. */}
      <Route path="/partner/m/podcast" element={
        <ProtectedRoute>
          <Layout>
            <MobilePodcast />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/profile" element={
        <ProtectedRoute>
          <Layout>
            <ProfileSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/staff/profile" element={<Navigate to="/partner/profile" replace />} />
      {/* Landing page for any ProtectedRoute denial. Auth-only, with NO role/team gate of its own
          so it can never bounce the user into a redirect loop. */}
      <Route path="/access-denied" element={
        <ProtectedRoute>
          <Layout>
            <AccessDenied />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/blog-management" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <Layout>
            <BlogManagement />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/staff/blog-management" element={<Navigate to="/partner/blog-management" replace />} />
      <Route path="/partner/internal-distribution" element={
        <ProtectedRoute>
          <Layout>
            <InternalDistribution />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/staff/internal-distribution" element={<Navigate to="/partner/internal-distribution" replace />} />
      <Route path="/partner/document-library" element={
        <ProtectedRoute>
          <Layout>
            <DocumentLibrary />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/staff/document-library" element={<Navigate to="/partner/document-library" replace />} />
      <Route path="/partner/adviser-assist-editor" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <AdviserAssistEditor />
          </Layout>
        </ProtectedRoute>
      } />

      {/* Portfolio Management routes - Investment team only */}
      <Route path="/partner/portfoliomanagement/p" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <BenchmarkLayout />
          </Layout>
        </ProtectedRoute>
      }>
        <Route index element={<BenchmarkDashboard />} />
        <Route path="funds" element={<ProtectedRoute requiredTeam="Investment"><FundManagement /></ProtectedRoute>} />
        <Route path="sector-weightings" element={<FundSectorWeightingsTabs side="p" />} />
        <Route path="p-sector-weightings" element={<PSectorWeightings />} />
        <Route path="trades" element={<TradeLog />} />
        <Route path="universe" element={<InvestableUniverse />} />
        <Route path="risk" element={<PRiskLayout />}>
          <Route index element={<PVaR />} />
          <Route path="var" element={<PVaR />} />
          <Route path="stress" element={<PStress />} />
          <Route path="board" element={<PBoard />} />
        </Route>
      </Route>
      {/* R Portfolio Management routes - Investment team only */}
      <Route path="/partner/portfoliomanagement/r" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <RBenchmarkLayout />
          </Layout>
        </ProtectedRoute>
      }>
        <Route index element={<RBenchmarkDashboard />} />
        <Route path="funds" element={<ProtectedRoute requiredTeam="Investment"><RFundManagement /></ProtectedRoute>} />
        <Route path="sector-weightings" element={<FundSectorWeightingsTabs side="r" />} />
        <Route path="r-sector-weightings" element={<RSectorWeightings />} />
        <Route path="hypothetical-calculator" element={<RHypotheticalCalculator />} />
        <Route path="trades" element={<RTradeLog />} />
        <Route path="universe" element={<InvestableUniverse />} />
        <Route path="risk" element={<RRiskLayout />}>
          <Route index element={<RVaR />} />
          <Route path="var" element={<RVaR />} />
          <Route path="stress" element={<RStress />} />
          <Route path="board" element={<RBoard />} />
        </Route>
      </Route>
      {/* Dist Portfolio Management routes - Investment team only */}
      <Route path="/partner/portfoliomanagement/dist" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <DistBenchmarkLayout />
          </Layout>
        </ProtectedRoute>
      }>
        <Route index element={<DistBenchmarkDashboard />} />
        <Route path="funds" element={<ProtectedRoute requiredTeam="Investment"><DistFundManagement /></ProtectedRoute>} />
        <Route path="sector-weightings" element={<FundSectorWeightingsTabs side="dist" />} />
        <Route path="dist-sector-weightings" element={<DistSectorWeightings />} />
        <Route path="hypothetical-calculator" element={<DistHypotheticalCalculator />} />
        <Route path="trades" element={<DistTradeLog />} />
        <Route path="universe" element={<InvestableUniverse />} />
      </Route>
      {/* MM Portfolio Management routes - Investment team only */}
      <Route path="/partner/portfoliomanagement/mm" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <MmBenchmarkLayout />
          </Layout>
        </ProtectedRoute>
      }>
        <Route index element={<MmBenchmarkDashboard />} />
        <Route path="funds" element={<ProtectedRoute requiredTeam="Investment"><MmFundManagement /></ProtectedRoute>} />
        <Route path="sector-weightings" element={<FundSectorWeightingsTabs side="mm" />} />
        <Route path="mm-sector-weightings" element={<MmSectorWeightings />} />
        <Route path="holdings-duration" element={<MmHoldingsDuration />} />
        <Route path="trades" element={<MmTradeLog />} />
        <Route path="universe" element={<InvestableUniverse />} />
      </Route>

      {/* Backward-compat redirect */}
      <Route path="/partner/benchmark" element={<Navigate to="/partner/portfoliomanagement/p" replace />} />
      <Route path="/partner/benchmark/:sub" element={<Navigate to="/partner/portfoliomanagement/p" replace />} />

      {/* Benchmark Maintenance routes - Investment team + Admin */}
      <Route path="/partner/benchmark-maintenance" element={
        <ProtectedRoute>
          <Layout>
            <BenchmarkMaintenanceLayout />
          </Layout>
        </ProtectedRoute>
      }>
        <Route index element={<BenchmarkSummary />} />
        <Route path="summary" element={<BenchmarkSummary />} />
        <Route path="mapping" element={<FundHouseSectorMapping />} />
        <Route path="holdings" element={<FundHouseHoldings />} />
        <Route path="fund-house" element={<BenchmarkSummary />} />
        <Route path="audit" element={
          <ProtectedRoute requiredRoles={['superadmin']}>
            <BMAuditTrail />
          </ProtectedRoute>
        } />
      </Route>
      <Route path="/partner/adviser-client-presentation" element={
        <ProtectedRoute>
          <Layout>
            <AdviserClientPresentation />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/cbam-mm-reporting" element={
        <ProtectedRoute>
          <Layout>
            <CBAMMMReporting />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/compliance" element={
        <ProtectedRoute requiredRoles={['admin','superadmin']}>
          <Layout>
            <ComplianceLayout />
          </Layout>
        </ProtectedRoute>
      }>
        <Route index element={<ComplianceDashboard />} />
        <Route path="breaches" element={<ComplianceBreaches />} />
        <Route path="governance" element={<ComplianceGovernance />} />
        <Route path="conflicts" element={<ComplianceConflicts />} />
        <Route path="mi" element={<ComplianceMI />} />
        <Route path="amendments" element={<ComplianceAmendments />} />
        <Route path="thresholds" element={<ComplianceThresholds />} />
        <Route path="threshold-provenance" element={<ThresholdProvenance />} />
      </Route>
      <Route path="/partner/policy-centre/tier-1" element={
        <ProtectedRoute>
          <Layout>
            <Tier1Policy />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/partner/policy-centre/tier-1/section/:sectionNumber" element={
        <ProtectedRoute>
          <Layout>
            <Tier1PolicySection />
          </Layout>
        </ProtectedRoute>
      } />

      {/* Protected admin routes */}
      <Route path="/admin/dashboard" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/portfolio-management" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <PortfolioManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/security" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <SecurityDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/client-docs" element={
        <ProtectedRoute requiredTeam="Investment">
          <ClientDocsManager />
        </ProtectedRoute>
      } />
      <Route path="/admin/about-editor" element={
        <ProtectedRoute requiredRoles={['superadmin']}>
          <AboutEditor />
        </ProtectedRoute>
      } />
      {/* admin AND superadmin (ported from PR #48, which landed on main mid-rebase). The route was
          the outlier: Tier1PolicyEditor's own in-page guard has always permitted admin OR superadmin
          and the navbar advertised it to admins, so the route alone bounced them. NB
          /admin/about-editor above stays superadmin-only — same mismatch, deliberately not changed. */}
      <Route path="/admin/tier1-policy-editor" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <Layout>
            <Tier1PolicyEditor />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/admin/team-management" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <Layout>
            <TeamManagement />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Podcast publish — one-drop admin upload page (mp4 in, storage + YouTube + RSS out). */}
      <Route path="/admin/podcast" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <PodcastAdmin />
          </Layout>
        </ProtectedRoute>
      } />
      {/* Phase 3 (A1) — external-adviser provisioning: create firms + issue invites. Admin-gated.
          AdvisersAdmin renders its own Layout, so no <Layout> wrapper here. */}
      <Route path="/admin/advisers" element={
        <ProtectedRoute requiredRoles={['admin', 'superadmin']}>
          <AdvisersAdmin />
        </ProtectedRoute>
      } />

      {/* ── CBAM native meetings module (Investment-team gated) ──────────────────────────────────
          Request / Booked / Report replaced three Google Forms; reference-data is their admin CRUD.
          NB /meeting-request was UNGATED on this branch because the gate was added on main after the
          branch was cut. Restoring requiredTeam="Investment" here — shipping this branch without it
          would have silently removed authentication from the meeting request form. */}
      <Route path="/meeting-request" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <MeetingRequest />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/meeting-booked" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <MeetingBooked />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/meeting-report" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <MeetingReport />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/meetings/reference-data" element={
        <ProtectedRoute requiredTeam="Investment">
          <Layout>
            <MeetingsReferenceData />
          </Layout>
        </ProtectedRoute>
      } />

      {/* Mobile "My Captures" — the caller's own recordings/memos/notes with a live status pill. */}
      <Route path="/partner/m/captures" element={
        <ProtectedRoute>
          <Layout>
            <MobileMyCaptures />
          </Layout>
        </ProtectedRoute>
      } />

      {/* ── Investment Reporting island (dark behind the investment_reporting_enabled flag) ──────
          Review + sign-off shell. Sibling to /partner/research, NOT nested under it — nesting would
          put it behind that fragment's `:id` catch-all. Auth-only ProtectedRoute; the
          Investment/Operations/admin gate is done in the layout via can_review_reporting() so client
          gating matches the RLS. DELIBERATELY NOT requiredTeam="Investment" (that wrongly excludes
          Operations). The flag gate lives in InvestmentReportingLayout, not here, so every child
          route inherits it. */}
      {/* Markets. Investment Team only, by Sam's ruling on 2026-09-04, REVERSING the staff-wide
          decision of 2026-08-27 recorded here previously.

          This composes public-domain curve data with the PROPRIETARY IG price feed, so it stays in
          the internal-only graph and must not reach the adviser or public bundles.

          requiredTeam="Investment" also admits admin and superadmin (ProtectedRoute), which is
          exactly what canInvestmentRoutes resolves to in PartnerNavbar, where the matching link gate
          lives. Change the two together: gating only the link leaves this URL reachable by any
          signed-in staff member, and gating only the route advertises a page the router denies. */}
      <Route
        path="/partner/markets"
        element={
          <ProtectedRoute requiredTeam="Investment">
            <Layout>
              <PartnerMarkets />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/partner/investment-reporting"
        element={
          <ProtectedRoute>
            <Layout>
              <InvestmentReportingLayout />
            </Layout>
          </ProtectedRoute>
        }
      >
        {/* island index: the cycle list */}
        <Route index element={<ReportingCycleList />} />

        {/* per-cycle shell: report | flags | artifacts | newsletter | gate | intake | sleeves | yardeni | yardeni/curate */}
        <Route path=":cycleId" element={<ReportingCycleLayout />}>
          <Route index element={<ReportingCycleIndex />} />   {/* -> report */}
          <Route path="report" element={<ReportTab />} />
          <Route path="flags" element={<FlagsTab />} />
          <Route path="artifacts" element={<ArtifactsTab />} />
          {/* Review-before-send: the retail COPY review, a distinct act from the gate's
              sign-off on the NUMBERS. Neither implies the other. */}
          <Route path="newsletter" element={<NewsletterTab />} />
          <Route path="gate" element={<GateTab />} />
          <Route path="intake" element={<IntakeTab />} />
          {/* 0003v sleeve roster + the confirm_sleeve control. */}
          <Route path="sleeves" element={<SleevesTab />} />
          {/* Track 1d — Yardeni market_context slot. Both read the same CycleContext (cycle,
              ir, isAdmin) as the other tabs via useOutletContext, so no extra provider is needed. */}
          <Route path="yardeni" element={<YardeniSecondOpinion />} />
          <Route path="yardeni/curate" element={<YardeniCurate />} />
        </Route>
      </Route>

      {/* Fund Manager Forms - these need layout */}
      <Route path="/fund-manager-forms/:formId" element={
        <Layout>
          <FundManagerForms />
        </Layout>
      } />

      {/* Year End Review moved to src/routes/publicRoutes.tsx — it is ungated marketing content
          linked from the public /blog page, and living in this internal-only fragment made that
          link dead in the adviser and public bundles. */}
    </>
  );
}
